import { Link } from 'react-router-dom';
import { useFeature } from '../../context/AuthContext';
import './DeniedState.css';

/**
 * The one "you can't open this" page state: shared page header plus a way
 * back home, so a denied route is never a dead end. Used by ProtectedRoute
 * and by pages that discover the denial themselves (e.g. a department the
 * viewer doesn't manage). The Home label follows home_dashboard, like the 404.
 */
export default function DeniedState({ title, message, eyebrow = null, className = 'main-content-inner' }) {
  const homeOn = useFeature('home_dashboard');
  return (
    <div className={className}>
      <header className="page-head">
        {eyebrow && <p className="page-eyebrow">{eyebrow}</p>}
        <h1 className="page-title">{title}</h1>
        <p className="page-subtitle denied-state__message">{message}</p>
        <Link className="btn btn-secondary btn-small" to="/">{homeOn ? 'Go to Home' : 'Go to My tools'}</Link>
      </header>
    </div>
  );
}

/** Route-level loading line: announced as busy, laid out like page content. */
export function LoadingState({ label = 'Loading…' }) {
  return (
    <div className="main-content-inner" role="status" aria-busy="true">
      <p className="page-subtitle">{label}</p>
    </div>
  );
}
